import React, { Component } from 'react';
import styled from 'styled-components';
import fitvids from 'fitvids';
import shortid from 'shortid';

import css from 'css';
import Html from 'partials/Html';
import Container from 'partials/Container';
import AnimateIn from 'partials/AnimateIn';

class Video extends Component {

    constructor(props) {
        super(props);

        // Prefix so #id is a valid querySelector selector (IDs must not start with a digit).
        this.id = 'fv-' + shortid.generate();
    }

    componentDidMount() {
        fitvids('#'+this.id);

        document.getElementById(this.id).firstChild.style.paddingTop = '56.25%';
    }

    _youtubeId(url) {
        let videoId = url.split('v=')[1];
        const ampersandPosition = videoId.indexOf('&');
        if(ampersandPosition !== -1) {
            videoId = videoId.substring(0, ampersandPosition);
        }
        return videoId;
    }

    _vimeoId(url) {
        const regExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
        const match = url.match(regExp);
        return match.length > 1 ? match[2] : '';
    }

    render() {
        const { data } = this.props;
        //console.log('Video:',data);

        const source = ~data.video_link.indexOf('vimeo') ? 'vimeo' : 'youtube';
        const id = source === 'vimeo' ? this._vimeoId(data.video_link) : this._youtubeId(data.video_link);
        const url = source === 'vimeo' ? 'https://player.vimeo.com/video/'+id : 'https://www.youtube.com/embed/'+id+'?rel=0';

        return (
            <ModuleWrapper description={data.show_description}>
                <AnimateIn>
                    <Container flex wrap>
                        {data.show_description &&
                            <div className="description">
                                <Html content>{data.description}</Html>
                            </div>
                        }
                        <div id={this.id} className="video">
                            <iframe src={url} title={'video-'+id} width="640" height="360" frameBorder="0" webkitallowfullscreen="true" mozllowfullscreen="true" allowFullScreen="true" ></iframe>
                        </div>
                    </Container>
                </AnimateIn>
            </ModuleWrapper>
        );
    }
}

export default Video;

const ModuleWrapper = styled.div`
    margin-bottom:60px;
    background: ${css.colors.pink};
    padding: 150px 0;
    @media(max-width: 1200px) {
        padding: 40px 0 30px;
    }
    @media (max-width: 767px) {
        margin-bottom:40px;
        padding-bottom: 20px;
    }

    ${props => props.description ? `
        .video {
            width:60%;
            @media (max-width: 960px) {
                width:100%;
                order:1;
                display: flex;
                margin-bottom:30px;
            }
        }
        .description {
            width:40%;
            padding-right: 40px;
            display:flex;
            flex-direction:column;
            justify-content: center;
            @media (max-width: 960px) {
                width:100%;
                padding-right:0;
                order: 2;
            }
        }
    ` : ``}
`


// WEBPACK FOOTER //
// ./src/partials/modules/Video.js